<!-- Topbar — Tailwind, glass effect, no logo (sidebar owns it) -->
<div class="h-16 bg-white/80 dark:bg-slate-800/80 backdrop-blur-xl border-b border-slate-100/80 dark:border-slate-800/60 px-4 flex items-center justify-between sticky top-0 z-20">

  <!-- Left: hamburger + toggle Responsable/Empleado -->
  <div class="flex items-center gap-2">
    <button class="w-8 h-8 flex items-center justify-center rounded-lg text-slate-500 dark:text-slate-400 hover:bg-blue-50 dark:hover:bg-white/5 hover:text-blue-700 dark:hover:text-blue-300 transition-all"
      (click)="appMain.onMenuButtonClick($event)">
      <i class="pi pi-bars text-sm"></i>
    </button>
    <ng-container *ngTemplateOutlet="statusRef.toggleTpl"></ng-container>
  </div>

  <!-- Instancia única de estado: no renderiza nada visible en modo compact, sólo expone los templates -->
  <app-status #statusRef="appStatus" [compact]="true"></app-status>

  <!-- Right: fichaje + contador, theme toggle + user -->
  <div class="flex items-center gap-1">

    <!-- Entrar + contador -->
    <div class="mr-3">
      <ng-container *ngTemplateOutlet="statusRef.actionTpl"></ng-container>
    </div>

    <!-- Theme toggle -->
    <button class="yb-icon-btn w-8 h-8 flex items-center justify-center rounded-lg text-slate-500 dark:text-slate-400 hover:bg-blue-50 dark:hover:bg-white/5 hover:text-blue-700 dark:hover:text-blue-300"
      (click)="toggleTheme()"
      [title]="isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
      <i [class]="isDark ? 'pi pi-sun text-xs' : 'pi pi-moon text-xs'"></i>
    </button>

    <!-- User avatar + dropdown -->
    <div class="relative ml-1" #profile
      [class.active-topmenuitem]="appMain.activeTopbarItem === profile">
      @if (!loading) {
        <!-- Campanita de notificaciones: hover/click independiente del botón del avatar -->
        <button class="yb-icon-btn w-8 h-8 inline-flex items-center justify-center rounded-lg text-slate-500 dark:text-slate-400 hover:bg-blue-50 dark:hover:bg-white/5 hover:text-blue-700 dark:hover:text-blue-300 align-middle mr-2"
          (click)="$event.stopPropagation()">
          <ng-container *ngTemplateOutlet="avatarRef.bellTpl"></ng-container>
        </button>

        <button class="inline-flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-blue-50 dark:hover:bg-white/5 transition-all align-middle"
          (click)="appMain.onTopbarItemClick($event, profile)">
          <app-avatar #avatarRef="appAvatar" [employeeId]="employeeId" [profile]="profile"></app-avatar>
        </button>

        <!-- Dropdown -->
        <ul class="absolute right-0 top-full mt-1 w-48 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-lg overflow-hidden z-50 py-1"
          [class.hidden]="appMain.activeTopbarItem !== profile">
          @if (avatarRef.userName) {
            <li class="px-4 py-2.5 border-b border-slate-100 dark:border-slate-700">
              <p class="text-xs font-medium text-slate-700 dark:text-slate-200 truncate m-0">{{ avatarRef.userName }}</p>
            </li>
          }
          @if (!isAdmin) {
            <li>
              <a routerLink="/account/profile"
                class="flex items-center gap-2.5 px-4 py-2.5 text-xs text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-white/5 transition-colors no-underline">
                <i class="pi pi-user text-xs text-slate-400"></i>
                <span>Perfil</span>
              </a>
            </li>
          }
          <li>
            <a routerLink="/account/configuration"
              class="flex items-center gap-2.5 px-4 py-2.5 text-xs text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-white/5 transition-colors no-underline">
              <i class="pi pi-cog text-xs text-slate-400"></i>
              <span>Configuraci&#xF3;n</span>
            </a>
          </li>
          <li class="border-t border-slate-100 dark:border-slate-700 mt-1 pt-1">
            <a (click)="logout()"
              class="flex items-center gap-2.5 px-4 py-2.5 text-xs text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer no-underline">
              <i class="pi pi-sign-out text-xs"></i>
              <span>Salir</span>
            </a>
          </li>
        </ul>
      }
    </div>
  </div>
</div>
